<template>
  <div class="shopCar">
    <div class="noGoods" v-if="!goods.length">
      <img src="../assets/car/carImg.png" alt />
      <span class="t1">购物车还是空的</span>
      <span class="t2">快去挑自己喜欢的吧~</span>
      <router-link class="goHome" tag="div" to="/index">去逛逛</router-link>
    </div>

    <div class="goodsBox">
      <div class="item" v-for="(item,index) in goods" :key="item.id">
        <div class="check" @click="item.is_sel=!item.is_sel">
          <img :src="item.is_sel ? imgs[0]:imgs[1]" />
        </div>
        <img class="goodsImg" :src="item.products_pic" @click="toGoodsDetail(item)"  />
        <div class="infor">
          <h6  @click="toGoodsDetail(item)">{{ item.products_title }}</h6>
          <span  @click="toGoodsDetail(item)" class="specs">{{ item.products_sku_title }}</span>
          <div class="price">
            <span class="newPrice">￥{{ item.price }}</span>
            <span class="oldPrice">￥{{ item.price_del }}</span>
            <div class="numBox">
              <img src="../assets/shop/reduce.png" @click="reduce(index)" />
              <span>{{ item.num }}</span>
              <img src="../assets/shop/add.png" @click="add(index,item.products_sku_stock_num)" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="settlement">
      <div class="check" @click="changeAll">
        <img :src="is_all ? imgs[0]: imgs[1]" alt />
        <span>全选</span>
      </div>
      <div class="total">
        <span class="t1">合计：</span>
        <span class="t2">￥{{ sum }}</span>
      </div>
      <div class="account" :style="sum == 0 && 'background:#999'" @click="commit">去结算</div>
    </div>
  </div>
</template>

<script>
// import { constants } from 'crypto'
// import Settlement from '../component/shopCar/Settlement'

export default {
  components: {
    // Settlement
  },
  data() {
    return {
      imgs: [
        require("../assets/car/is_sel.png"),
        require("../assets/car/no_sel.png")
      ],
      goods: []
    };
  },
  computed: {
    is_all() {
      let goods = this.goods;
      let index = goods.findIndex(item => item.is_sel == false);
      if (index == -1) {
        // 全被选中
        return true;
      } else {
        // 未被全选中
        return false;
      }
    },
   
    sum() {
      let goods = this.goods;
      let sum = 0;
      goods.forEach(item => {
        if (item.is_sel) {
          sum += item.num * item.price * 100;
        }
      });
      return (sum / 100).toFixed(2);
    }
  },
  created() {
    this.getMyCar();
  },
  methods: {
     toGoodsDetail({products_id}){
       this.$router.push(`/goodsDetail?id=${products_id}&type=1`)
       
    },
    // 获取购物车列表
    getMyCar() {
      this.$http({
        url: "car"
      }).then(res => {
        if(typeof res == 'string') return
        if(!res.length) return 
        res.forEach(item => (item.is_sel = false));
        this.goods = res;
      });
    },

    // 切换全选
    changeAll() {
      let goods = this.goods;
      if (this.is_all) {
        goods.forEach(item => (item.is_sel = false));
      } else {
        goods.forEach(item => (item.is_sel = true));
      }
    },
    reduce(index) {
      let data = this.goods[index];
      data.num--;
      if(data.num ==0) {
        console.log(1)
        this.goods.splice(index,1)
      }else{
        this.goods[index] = data
      }
      this.$http({
        url: "changeNum",
        data: {
          cart_id: data.id,
          num: "-1"
        }
      });
    },
    add(index, max) {
      let data = this.goods[index];
      if (data.num == max) return this.$toast(`最大库存为${max}`);
      data.num++;
      this.goods[index] = data;

      this.$http({
        url: "changeNum",
        data: {
          cart_id: data.id,
          num: 1
        }
      });
    },
    commit() {

      if(!this.goods.length) return this.$toast('购物车为空')

      if(this.sum ==0) return this.$toast('请先选中商品再点击结算')

      let goods = this.goods;

      let selCarList = goods.filter(item => item.is_sel == true);

      if(selCarList.some(item=>item.num >item.products_sku_stock_num)) {
        let arr = selCarList.filter(item=>item.num > item.products_sku_stock_num)
        console.log(arr)
        let msg = arr[0].products_title
        
        return this.$dialog.alert({message:`${msg}库存不足`})
      }

      selCarList = selCarList.map(item=>{
        item.goods_type = 1
        return item
      })


      
      // 提交数据到store中
      this.$store.commit("setCarList", selCarList);


      this.$store.commit('setSelAddr',{})
      
      this.$router.push({ name: "orderCommit", query: { is_buy: '0' } });
    }
  }
};
</script>

<style lang="less" scoped>
.shopCar {
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 30px;
  background-color: #fff;
  padding-bottom: 100px;
  .settlement {
    position: fixed;
    bottom: 100px;
    left: 0;
    height: 100px;
    width: 100%;
    box-sizing: border-box;
    padding-left: 24px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .check {
      display: flex;
      align-items: center;
      flex: 1;
      img {
        width: 40px;
        height: 40px;
        margin-right: 12px;
      }
      span {
        font-size: 24px;
        color: #666;
      }
    }
    .total {
      display: flex;
      align-items: center;
      font-size: 28px;
      margin-right: 10px;
      .t1 {
        color: #333;
        margin-right: 0px;
      }
      .t2 {
        color: #e42129;
      }
    }
    .account {
      height: 100px;
      width: 290px;
      text-align: center;
      line-height: 100px;
      font-size: 32px;
      color: #fff;
      background-color: #e42129;
    }
  }
  .noGoods {
    display: flex;
    align-items: center;
    flex-direction: column;
    img {
      width: 260px;
      margin-right: 40px;
    }
    .t1 {
      font-size: 30px;
      color: #333;
      margin: 50px auto 15px;
    }
    .t2 {
      font-size: 24px;
      color: #666;
    }
    .goHome {
      width: 218px;
      height: 72px;
      border: 1Px solid #e42129;
      color: #e42129;
      line-height: 72px;
      text-align: center;
      font-size: 30px;
      border-radius: 10px;
      margin-top: 50px;
    }
  }
  .goodsBox {
    width: 100%;
    box-sizing: border-box;
    padding: 0 24px;
    .item {
      margin: 30px 0;
      display: flex;
      align-items: center;
      .check img {
        width: 36px;
        height: 36px;
        margin-right: 20px;
      }
      .goodsImg {
        width: 160px;
        height: 160px;
        overflow: hidden;
        border: 1px solid #eee;
      }
      .infor {
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        margin-left: 10px;
        h6 {
          font-size: 30px;
          font-weight: 500;
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin: 0;
        }
        .specs {
          font-size: 22px;
          color: #666;
          margin: 15px 0 60px;
        }
        .price {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .newPrice {
            font-size: 30px;
            color: #e42129;
          }
          .oldPrice {
            font-size: 22px;
            color: #999;
            text-decoration: line-through;
          }
          .numBox {
            display: flex;
            flex: 1;
            align-items: center;
            justify-content: flex-end;
            img {
              width: 46px;
              height: 46px;
            }
            span {
              font-size: 28px;
              padding: 0 10px;
            }
          }
        }
      }
    }
  }
}
</style>
